export default __webpack_public_path__ + "static/media/gallery_3_1280.4c63d844.webp";